import { DocumentUpdate } from '../../document/models/request'
import createDocumentDeleter from '../../document/components/createDocumentDeleter'

interface DeleteHouseConsignmentDocumentsProps {
  documentsToDelete: DocumentUpdate[]
}

export default function useDeleteHouseConsignmentDocuments() {
  const deleteHouseConsignmentDocuments = async ({ documentsToDelete }: DeleteHouseConsignmentDocumentsProps) => {
    const deleteDocuments = createDocumentDeleter()
    return deleteDocuments(documentsToDelete)
  }

  return { deleteHouseConsignmentDocuments }
}
